import CloseIcon from '@mui/icons-material/Close';
import { RefuseProposalInputModel } from 'inputModels';
import React, { useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import Modal from 'react-modal';
import { IDemandProposalViewModal } from 'viewModels';
import { useTheme } from 'styled-components';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/iconExclamation.svg';
import { ReactComponent as ExpandArrowIcon } from '../../../assets/icons/iconExpandArrow.svg';
import { SolicitationController } from '../../../controller/SolicitationController';
import { labelRefusalReason, RefusalReason } from '../../../types/enums';
import { Button } from '../../Buttons/Button';
import { SelectControled } from '../../SelectControled';
import { Content, Header } from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  proposal: IDemandProposalViewModal;
  zIndex?: number;
}

export function ModalRefuseProposal({ isOpen, onRequestClose, proposal, zIndex }: Props) {
  const theme = useTheme();
  const [saveLetterText, setSaveLetterText] = useState('');

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
      },
    },
  };

  const [defaultValues] = useState({
    type: Number(''),
  });

  const { control, setValue } = useForm({
    defaultValues,
    reValidateMode: 'onChange',
  });

  const [type] = useWatch({
    control,
    name: ['type'],
  });

  const handleSaveText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSaveLetterText(e.target.value);
  };

  const handleSendRefusal = () => {
    const refusal: RefuseProposalInputModel = {
      requestsSubmittedId: proposal.requestSubmitted.id as string,
      refusalReason: type,
      justificationRefusal: saveLetterText,
    };

    SolicitationController.refuseProposal(refusal).then(() => {});
    onRequestClose();
  };

  const setZIndex =
    zIndex !== undefined
      ? {
          overlay: {
            zIndex,
          },
        }
      : {};

  return (
    <Modal
      style={setZIndex}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-edit-modal-content">
      <Header>
        <div className="content-header">
          <ExclamationIcon />
          <h1>Recusar proposta</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>

      <Content>
        <SelectControled
          name="type"
          control={control}
          MenuProps={MenuProps}
          IconComponent={ExpandArrowIcon}
          defaultValue=""
          onChange={(e) => {
            setValue('type', e.target.value as number);
          }}
          placeholderTitle="Selecione"
          itens={Object.keys(RefusalReason)
            .filter((refusalType) => !isNaN(Number(refusalType)))
            .map((refusalType) => ({
              id: refusalType,
              value: labelRefusalReason[refusalType as unknown as RefusalReason],
            }))}
        />
        <p>Escreva mais detalhes da recusa para o solicitante.</p>
        <textarea name="details" id="details" cols={30} rows={6} onChange={handleSaveText} />

        <div className="buttons">
          <Button
            text="Descartar"
            dimensions={{ width: '12rem', height: '2rem' }}
            color="background_white"
            backgroundHoverColor="tertiary_500"
            border={{ color: 'transparent', width: 1 }}
            textHoverColor="background_white"
            onClick={() => onRequestClose()}
          />
          <Button
            text="Enviar recusa"
            dimensions={{ width: '12rem', height: '2rem' }}
            color="background_white"
            backgroundHoverColor="primary"
            background="secondary"
            textHoverColor="background_white"
            border={{ color: 'transparent', width: 1 }}
            onClick={handleSendRefusal}
          />
        </div>
      </Content>
    </Modal>
  );
}
